
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Bestcabserviceinpune() {



    const cardData =
    {
        keyword: 'Best Cab Service in Pune',
        heading: 'Meghana Cab : Best Cab Service in Pune ',
        headingDescription: 'Meghana Cab is widely regarded as one of the best cab services in Pune, offering reliable, comfortable, and professional travel solutions across local and intercity routes. Whether you are booking for airport transfers, city tours, or outstation trips, our fleet of well-maintained AC sedans, SUVs, and tempo travellers ensures you ride in style and safety. With experienced, verified drivers, transparent pricing, on-time pickups, and 24/7 customer support, we make every journey smooth and stress-free. Choose Meghana Cab in Pune for dependable service, flexible booking options, and a customer-first travel experience that truly stands out.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada Fort",
    "description": "Shaniwar Wada stands as Pune’s most iconic landmark — a majestic fort that was once the royal seat of the Peshwas of the Maratha Empire. Built in 1732, its massive stone walls, intricate wooden gates, and sprawling courtyards narrate tales of valor, politics, and romance. The grand Delhi Gate welcomes visitors into a world of Maratha glory, where ruins still whisper stories of Bajirao I and Mastani. At night, a spectacular light and sound show brings the fort’s history alive under the stars. The lush gardens and historic aura make Shaniwar Wada a timeless reminder of Pune’s royal heritage and architectural splendor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace is not only an architectural gem but also a site of deep historical importance. Built in 1892 by Sultan Aga Khan III, this grand palace played a key role in India’s freedom struggle. It served as the prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace functions as a memorial and museum, showcasing photographs, personal items, and freedom movement memorabilia. Its Italian-style arches, manicured lawns, and serene surroundings make it both a place of learning and reflection — a tribute to peace, resilience, and India’s path to independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the Sahyadri ranges about 35 km from Pune, Sinhagad Fort offers breathtaking views and a thrilling sense of history. The fort, meaning ‘Lion’s Fort,’ was the site of the famous Battle of Sinhagad where the brave Maratha warrior Tanaji Malusare fought valiantly for Shivaji Maharaj. Trekking up the hill reveals ancient ramparts, gates, and bastions wrapped in mist and greenery. The local stalls serving piping-hot kanda bhaji and curd add rustic charm to the adventure. With its panoramic views, monsoon clouds, and heroic tales, Sinhagad is the perfect blend of nature, history, and Marathi pride."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered and visually stunning temples. Established over a century ago, it houses a magnificent idol of Lord Ganesha adorned with gold and precious ornaments. The temple attracts millions of devotees, especially during the grand Ganesh Chaturthi celebrations when the streets of Pune come alive with lights, music, and devotion. The temple’s intricate design, serene ambiance, and community-driven charity work make it a spiritual cornerstone of the city. Visiting Dagdusheth is not only a religious experience but also a glimpse into Pune’s deep-rooted cultural and devotional traditions."
  },
  {
    "title": "Parvati Hill and Temple Complex",
    "description": "Parvati Hill, standing gracefully at the city’s heart, offers panoramic views of Pune and a serene spiritual retreat. The hill is home to the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, along with several smaller shrines and a Peshwa museum. Climbing its 108 stone steps feels both meditative and rewarding as the city unfolds below. The temple’s calm ambiance, ancient sculptures, and scenic sunrise or sunset views make it a favorite for photographers and peace seekers. It remains a perfect blend of devotion, history, and natural beauty — an essential stop on any Pune itinerary."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum offers a fascinating glimpse into India’s diverse art and cultural heritage. Curated by Dr. Dinkar Kelkar in memory of his son, this three-storey museum houses over 20,000 artifacts — including antique musical instruments, rare sculptures, Mughal-era weaponry, and traditional Indian ornaments. The highlight is the reconstructed Mastani Mahal, showcasing royal décor and intricate woodwork from the Peshwa era. Every corridor tells a story of craftsmanship and creativity. For history enthusiasts and art lovers, the museum serves as a treasure trove that captures India’s timeless aesthetic and Pune’s cultural spirit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved from a single basalt rock in the 8th century, the Pataleshwar Cave Temple is one of Pune’s oldest architectural wonders. Dedicated to Lord Shiva, the temple features a massive Nandi bull, intricately sculpted pillars, and a circular stone courtyard that exudes divine tranquility. Despite being located along a busy road, the temple offers a peaceful oasis in the city. Its unique monolithic structure and ancient carvings transport visitors back to the times of the Rashtrakuta dynasty. For those interested in spirituality and history, Pataleshwar is a hidden gem reflecting Pune’s ancient roots and artistic mastery."
  },
  {
    "title": "Osho Ashram (OSHO International Meditation Resort)",
    "description": "Located in the leafy Koregaon Park area, the Osho Ashram is one of the world’s most renowned spiritual centers. Founded by spiritual teacher Osho Rajneesh, it offers meditation programs, wellness therapies, and peaceful gardens designed to promote inner balance. The ashram’s serene pathways, zen-like architecture, and marble meditation halls create an atmosphere of deep calm. Visitors from around the world come here to rejuvenate through yoga, silence, and mindfulness. Surrounded by upscale cafes and art boutiques, the Osho Ashram reflects Pune’s global, cosmopolitan soul while offering a sanctuary for peace and spiritual awakening."
  },
  {
    "title": "Khadakwasla Dam and Panshet Lake",
    "description": "Khadakwasla Dam, located on the Mutha River, is one of Pune’s most scenic picnic spots. The wide expanse of calm blue water against the backdrop of green hills creates a postcard-perfect landscape. It is also the source of the city’s water supply and lies close to the Indian National Defence Academy (NDA). A short drive further leads to Panshet and Varasgaon dams — ideal for boating, photography, and weekend getaways. The gentle breeze, monsoon mist, and local food stalls make the area a relaxing retreat. It’s where nature, adventure, and tranquility meet just outside the city limits."
  },
  {
    "title": "Vetal Tekdi and Pashan Lake",
    "description": "Vetal Tekdi, the highest point in Pune, offers panoramic views of the city and surrounding hills. Covered in dense vegetation, it’s a favorite spot for morning joggers, trekkers, and nature enthusiasts. The nearby Pashan Lake is a beautiful birdwatching site, home to migratory species like herons and kingfishers. Together, these natural escapes showcase Pune’s green soul amid its urban expansion. The peaceful sunrise views, cool breeze, and chirping birds provide a perfect start to the day. For travelers seeking calm, fitness, or photography, Vetal Tekdi and Pashan Lake deliver an unforgettable nature experience within city limits."
  }
],


       "services": [
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Looking for the best cab service from Pune to Mumbai? Choose Meghana Cab for reliable, comfortable, and affordable travel. Our fleet includes luxury Sedans, Ertiga, and Innova cars with experienced drivers ensuring a safe journey. We offer doorstep pickups, transparent pricing, and flexible booking options to make your Pune to Mumbai trip hassle-free."
    },
    {
      "name": "Best Outstation Cab Service in Pune",
      "description": "Meghana Cab provides the best outstation cab service in Pune, catering to long-distance travelers seeking comfort and convenience. Whether it's a family vacation, corporate trip, or weekend getaway, our well-maintained AC vehicles and professional chauffeurs ensure a smooth and enjoyable ride to your destination."
    },
    {
      "name": "Best Taxi Service in Pune",
      "description": "Experience the best taxi service in Pune with Meghana Cab. Our prompt pickups, courteous drivers, and clean vehicles make local and outstation travel effortless. Choose from a wide range of cars including Innova, Ertiga, and Sedans, all available at competitive rates with full transparency and no hidden charges."
    },
    {
      "name": "Best Cab Service Mumbai to Pune",
      "description": "Travel comfortably from Mumbai to Pune with Meghana Cab, known for its reliable and efficient cab services. Our fleet features premium cars equipped with modern amenities, professional drivers, and punctual service. Book now for one-way or round-trip journeys and enjoy competitive fares."
    },
    {
      "name": "Best Cab in Pune",
      "description": "Meghana Cab is your go-to for the best cab in Pune, offering top-quality vehicles, well-trained drivers, and excellent customer service. Whether you need a local ride or outstation trip, we provide affordable options tailored to your needs with real-time tracking and flexible scheduling."
    },
    {
      "name": "Best Mumbai Pune Cab Service",
      "description": "For the best Mumbai to Pune cab service, Meghana Cab stands out with its fleet of luxury and budget-friendly vehicles, experienced drivers, and timely service. Enjoy hassle-free bookings and travel in style and comfort on this popular route."
    },
    {
      "name": "Best Pune to Mumbai Cab Service",
      "description": "Looking for the best Pune to Mumbai cab service? Meghana Cab offers reliable, comfortable, and affordable options with professional chauffeurs and clean vehicles. We cater to solo travelers, families, and corporate clients with customizable packages and easy booking."
    },
    {
      "name": "Cheapest Cab Service in Pune",
      "description": "Travel smart with Meghana Cab’s cheapest cab service in Pune without compromising comfort or safety. Our budget-friendly rides come with transparent fares, punctual service, and well-maintained cars to get you anywhere in or outside Pune affordably."
    },
    {
      "name": "Cheap Cabs in Pune",
      "description": "Need cheap cabs in Pune? Meghana Cab offers pocket-friendly pricing on quality cabs. Choose from Sedans, Ertiga, and Innova vehicles for local or outstation trips with guaranteed safety and timely pickups."
    },
    {
      "name": "Cheapest Cab from Mumbai to Pune",
      "description": "Book the cheapest cab from Mumbai to Pune with Meghana Cab, offering affordable fares, safe vehicles, and professional drivers. Enjoy a hassle-free travel experience with door-to-door service and on-time arrival."
    },
    {
      "name": "Cheapest Taxi Service in Pune",
      "description": "Get the cheapest taxi service in Pune with Meghana Cab, where affordability meets reliability. We provide well-maintained vehicles, skilled drivers, and convenient booking options to ensure a smooth ride every time."
    },
    {
      "name": "Outstation Cab Booking Pune",
      "description": "Easily book outstation cabs from Pune with Meghana Cab for your next trip. Our extensive fleet of Innova, Ertiga, and Sedan vehicles is ready to take you to your favorite destinations with comfort and safety."
    },
    {
      "name": "Outstation Cabs Pune",
      "description": "Meghana Cab offers trusted outstation cabs from Pune, perfect for long-distance travel. Enjoy air-conditioned rides, professional drivers, and competitive prices for trips to Mumbai, Goa, Nashik, and beyond."
    },
    {
      "name": "Outstation Taxi Service Pune",
      "description": "Choose Meghana Cab for reliable outstation taxi services in Pune. Our fleet includes spacious Innova and comfortable Sedans, providing excellent travel experiences for families, groups, and solo travelers."
    },
    {
      "name": "Outstation Cab Service in Pune",
      "description": "Plan your outstation trips with Meghana Cab’s premium cab service in Pune. We ensure timely pickups, clean cars, and courteous drivers for a hassle-free journey to any destination across Maharashtra and neighboring states."
    },
    {
      "name": "Outstation Taxi in Pune",
      "description": "Meghana Cab is your trusted partner for outstation taxi rides from Pune. Our vehicles are sanitized, well-maintained, and driven by experienced drivers for safe, comfortable, and enjoyable travel."
    },
    {
      "name": "Outstation Innova Car Rental Pune",
      "description": "Rent an Innova for outstation trips from Pune with Meghana Cab. Perfect for families and groups, our Innova cars come with spacious seating, AC comfort, and professional drivers for a smooth journey."
    },
    {
      "name": "7 Seater Innova on Rent in Pune",
      "description": "Need a 7-seater Innova on rent in Pune? Meghana Cab offers well-maintained Innova vehicles ideal for group travel and family trips, providing comfort and reliability at competitive rates."
    },
    {
      "name": "8 Seater Innova on Rent Pune",
      "description": "Book an 8-seater Innova on rent in Pune with Meghana Cab for spacious and comfortable travel. Perfect for large groups or corporate outings with expert drivers and clean vehicles."
    },
    {
      "name": "Ertiga Outstation Booking Pune",
      "description": "Meghana Cab provides Ertiga outstation bookings from Pune for budget-friendly and comfortable travel. Our Ertiga cars are spacious, air-conditioned, and perfect for family trips or small groups."
    },
    {
      "name": "Outstation Sedan Cab Service",
      "description": "Experience affordable and comfortable outstation sedan cab service from Pune with Meghana Cab. Ideal for solo travelers and couples, our sedans offer a smooth ride with professional drivers and excellent customer support."
    }
  ],
  "tableData": [
    ["Best Cab Service Pune to Mumbai", "Best Outstation Cab Service in Pune"],
    ["Best Taxi Service in Pune", "Best Cab Service Mumbai to Pune"],
    ["Best Cab in Pune", "Best Mumbai Pune Cab Service"],
    ["Best Pune to Mumbai Cab Service", "Cheapest Cab Service in Pune"],
    ["Cheap Cabs in Pune", "Cheapest Cab from Mumbai to Pune"],
    ["Cheapest Taxi Service in Pune", "Outstation Cab Booking Pune"],
    ["Outstation Cabs Pune", "Outstation Taxi Service Pune"],
    ["Outstation Cab Service in Pune", "Outstation Taxi in Pune"],
    ["Outstation Innova Car Rental Pune", "7 Seater Innova on Rent in Pune"],
    ["8 Seater Innova on Rent Pune", "Ertiga Outstation Booking Pune"],
    ["Outstation Sedan Cab Service", ""]
  ],









"whychoose": [
    {
        "WhyChooseheading": "Top-Rated Cab Service in Pune",
        "WhyChoosedescription": "Meghana Cab is recognized as one of the best cab services in Pune, trusted by thousands for reliable, professional, and customer-friendly travel experiences."
    },
    {
        "WhyChooseheading": "Wide Range of Travel Options",
        "WhyChoosedescription": "Whether it’s airport transfers, outstation trips, local sightseeing, or business travel, Meghana Cab offers a variety of services to meet all your travel needs in Pune."
    },
    {
        "WhyChooseheading": "Well-Maintained and Clean Vehicles",
        "WhyChoosedescription": "Our fleet includes hatchbacks, sedans, SUVs, and tempo travellers — all sanitized regularly and equipped with safety features to ensure a secure and comfortable ride."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "All Meghana Cab drivers are licensed, experienced, and professional — committed to your safety, punctuality, and satisfaction on every trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive rates with no hidden costs. With Meghana Cab, you get clear, upfront pricing so you can plan your travel confidently."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability in Pune",
        "WhyChoosedescription": "Whether you need a cab at midnight or early morning, Meghana Cab is available around the clock to serve your travel requirements across Pune."
    },
    {
        "WhyChooseheading": "Instant Booking and Quick Confirmation",
        "WhyChoosedescription": "Book your cab in just a few clicks through our website or app. Get instant booking confirmation and real-time ride updates for peace of mind."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support",
        "WhyChoosedescription": "Our support team is available 24/7 to assist you with bookings, trip changes, and travel-related queries — making your ride seamless from start to finish."
    }
]





























    }









const faqData = [
    {
        question: "How can I book a cab with Meghana Cab in Pune?",
        answer: "You can book a cab in Pune easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What types of cabs are available for booking in Pune?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers to suit your group size and comfort preferences."
    },
    {
        question: "Do you offer both local and outstation cab services in Pune?",
        answer: "Yes, Meghana Cab provides both local city rides and outstation cab services from Pune to various destinations."
    },
    {
        question: "Are Meghana Cab drivers experienced and professional?",
        answer: "Yes, our drivers are well-trained, professional, and familiar with Pune routes and outstation journeys."
    },
    {
        question: "What are the fare options for cab rides in Pune?",
        answer: "Fares depend on the cab type and distance. We offer transparent pricing and will share exact fare details during booking."
    },
    {
        question: "Can I book a cab for airport transfers in Pune?",
        answer: "Absolutely, Meghana Cab provides timely and reliable airport transfer services to Pune Airport and nearby locations."
    },
    {
        question: "Is night time cab service available in Pune?",
        answer: "Yes, Meghana Cab operates 24/7, so you can book cabs any time of day or night."
    },
    {
        question: "What payment methods does Meghana Cab accept?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "Can I request additional stops or customize my trip?",
        answer: "Yes, you can request stops or customize your itinerary by informing us while booking."
    },
    {
        question: "How do I contact Meghana Cab for booking or support in Pune?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and customer support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided excellent service during my Pune city trips. The drivers are courteous and vehicles are clean.”'
    },
    {
        name: 'Mrs. Anjali Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I used Meghana Cab for an outstation trip from Pune. Very reliable and affordable service. Highly recommend!”'
    }
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Best Cab Service in Pune",
  "description": "Experience the best cab service in Pune with Meghana Cabs. Affordable and reliable outstation taxis, Innova, Ertiga, and sedan rentals for Pune to Mumbai trips and beyond. Book your cheap and comfortable ride today!",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5200"
  }
};




    return (
        <div>

<Helmet>
  <title>Best Cab Service in Pune | Affordable Outstation & Local Cabs @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book the best cab service in Pune with Meghana Cabs. Reliable outstation and local taxi services including Innova, Ertiga, and sedan cabs at affordable prices. Safe and comfortable travel guaranteed."
  />
  <meta
    name="keywords"
    content="best cab service pune to mumbai, best outstation cab service in pune, best taxi service in pune, Best cab service mumbai to pune, best cab in pune, best mumbai pune cab service, best pune to mumbai cab service, cheapest cab service in pune, Cheap cabs in pune, cheapest cab from mumbai to pune, cheapest taxi service in pune, outstation cab booking pune, Outstation cabs pune, Outstation taxi service pune, best outstation cab service in pune, Outstation cab service in pune, Outstation taxi service in pune, Outstation taxi in pune, outstation innova car rental pune, 7 seater innova on rent in pune, 8 seater innova on rent pune, ertiga outstation booking pune, Outstation Sedan Cab Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>






            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bestcabserviceinpune;